// ===========================================
// Survey API Configuration for TopCX Portal
// ===========================================
const apiBaseURL = process.env.REACT_APP_SURVEY_API_BASE || 'http://localhost:8000';

// ------------- Endpoints ----------------
const auth = `${apiBaseURL}/auth`;
const contact = `${apiBaseURL}/survey`;
const startIngestion = `${apiBaseURL}/settings/start_ingestion`;
const viewSettings = `${apiBaseURL}/settings/view_settings`;
const updateSettings = `${apiBaseURL}/settings/update_settings`;
const infoSettings = `${apiBaseURL}/settings/view_dashboard_info`;

export const SurveyApiConfig = {
  // Authentication
  xSurveyAuthCheck: `${auth}/update_checkup`,

  // Feature Management
  xSurveyDetails: `${viewSettings}/xsurvey`,
  xSurveyIngestion: `${startIngestion}/xsurvey`,
  xSurveyUpdateSettings: `${updateSettings}/xsurvey`,
  XSurveyOverallView: `${contact}/overall_view`,
  XSurveyGraph: `${contact}/survey_graph`,
  XSurveyFilter: `${contact}/get_survey_template_list`,
  xSurveyLicensesInfo: `${infoSettings}/survey`,

  // Stop Live Status
  stopLiveStatus: `${apiBaseURL}/stop-all-sse`,
};
